import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import getInteractionSeverity from './interactionsSeverityFunctions';
import { DrugToDiseaseInteractionAdminModel } from "../../../models/activeIngredient";
import { DiseaseForGridModel } from '../../../models/disease/diseaseForGridModel';
import { Lang } from '../../../common/enums';
import { DrugInteractionContentModel } from '../../../models/activeIngredient/drugInteractionContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

interface IProps {
  activeIngredient: ActiveIngredientAdminModel
  removeDiseaseInteractionClick: any,
  setIsVisibleDiseaseAddEditInteractionDialog: any,
  onAddEditDiseaseInteractionClick: any,
  setIsDiseaseDropdownDisabled: any
}

interface IState {
  validationMessage: string;
}

class ActiveIngredientTabDiseaseInteraction extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: ''
    };
  }

  handleDiseaseAddEditClick = (diseaseId, selectedIngredientId) => {
    if (!diseaseId) { // Add			
      let newDiseaseInteraction = new DrugToDiseaseInteractionAdminModel();
      newDiseaseInteraction.disease = new DiseaseForGridModel();
      newDiseaseInteraction.selectedIngredientId = selectedIngredientId;

      let contentList = new Array<DrugInteractionContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new DrugInteractionContentModel();
        content.langId = parseInt(Lang[k]);
        content.professionalDecscription = '';
        content.consumerDecscription = '';
        contentList.push(content);
      });

      newDiseaseInteraction.drugToDiseaseInteractionContent = contentList;

      this.handleDiseaseInteractionAddEditClick(newDiseaseInteraction, false);
    } else {
      let currentDiseaseInteraction = this.props.activeIngredient.drugToDiseaseInteractions.
        find(f => f.disease.diseaseId === diseaseId && f.selectedIngredientId === selectedIngredientId);
      if (currentDiseaseInteraction) {

        this.handleDiseaseInteractionAddEditClick(currentDiseaseInteraction, true);
      }
      else {
        this.setState({
          validationMessage: 'Erorororororo'
        });
      }
    }
  }

  handleDiseaseInteractionAddEditClick(diseaseInteraction: DrugToDiseaseInteractionAdminModel, isDisabled: boolean) {
    this.props.onAddEditDiseaseInteractionClick(diseaseInteraction)
    this.props.setIsVisibleDiseaseAddEditInteractionDialog(true);
    this.props.setIsDiseaseDropdownDisabled(isDisabled);
  }

  public render() {

    const { activeIngredient } = this.props;
    const currentActiveIngredientId = this.props.activeIngredient.activeIngredientId ? this.props.activeIngredient.activeIngredientId : -1;

    return (

      <div style={{ minHeight: '550px', maxHeight: '650px' }}>
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-12">
            <div className="mb-2">
              <button
                onClick={() => this.handleDiseaseAddEditClick(null, currentActiveIngredientId)}
                className="btn btn-success"
                style={{ marginRight: "5px" }}>
                Add New
									</button>
            </div>
            <DataTable
              value={activeIngredient.drugToDiseaseInteractions}
              dataKey='disease.diseaseId'
            >
              <Column
                header="Name"
                field="disease"
                body=
                {(rowData, column) =>
                  <div>
                    {rowData && rowData.disease.diseaseContent && rowData.disease.diseaseContent.length ?
                      rowData.disease.diseaseCode + ' / ' + rowData.disease.diseaseContent.map(r => r.diseaseName).filter(Boolean).join(' / ')
                      : rowData.disease.diseaseCode}
                  </div>
                }
              />
              <Column
                header="Interaction severity"
                field="interactionTypeId"
                body={(rowData, column) =>
                  <div>
                    {getInteractionSeverity('iconLabel', rowData.interactionTypeId)}
                  </div>}
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className="p-button-warning"
                      tooltip="Edit"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleDiseaseAddEditClick(rowData.disease.diseaseId, rowData.selectedIngredientId)}
                    />
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.props.removeDiseaseInteractionClick(rowData.selectedIngredientId, rowData.interactionTypeId, rowData.disease.diseaseId)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabDiseaseInteraction;